import React from 'react';

function BlockFooter({ title, link, iconSize = "medium" }) {
  return (
    <div className="d3-l-grid--outer">
      <div className="d3-l-grid--inner">
        <div className="d3-l-col__col-12">
          <div className="mls-o-block-footer">
            {
              link
                ? (
                  <a alt={title} className="mls-o-block-footer__title" href={link}>
                    <div className="mls-o-block-footer__text">
                      {title}
                      <span className={`oc-o-icon--chevron-right fa-icon-svg fa-icon-svg--${iconSize}`}>
                        <svg
                          className="fa-icon-svg fa-icon-svg--chevron-down" viewBox="0 0 20 20">
                          <use xlinkHref="#chevron-down" />
                        </svg>
                      </span>
                    </div>
                  </a>
                )
                : (
                  <div className="mls-o-block-footer__title">
                    {title}
                  </div>
                )
            }
          </div>
        </div>
      </div>
    </div>
  );
}

export default BlockFooter;
